import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { addressI, addressInitialState, Address } from 'app/core/interfaces/adress';
import { FormStateMatcher } from 'app/core/directives/form-validate';
import { MapService } from 'app/core/http/services/map.service';
import { ViaCepService } from 'app/core/http/services/viacep.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { PatientService } from 'app/core/http/services/patient.service';
import { Patient } from 'app/core/interfaces/patient';
import { SearchCepComponent } from 'app/modules/shared/components/map/search-cep/search-cep.component';
import { MatDialogConfig } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'page-patient-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class PatientMapComponent extends BaseComponent implements OnInit {
  @Input() form: FormGroup = new FormGroup({});
  @Input() address: Address = <Address>{};
  @Input() patient: Patient = <Patient>{};
  @Output() onUpdate = new EventEmitter<any>();
  @Output() onUpdatePatient = new EventEmitter<any>();
  @Input() mode = 'CREATE';

  private patientId?: string | number;
  public isSavingSettings = false;
  public childForm: FormGroup = new FormGroup({});
  readonly mapStateMatcher = new FormStateMatcher('');
  public url = '';
  public zoom = 14;

  public submittedCep = false

  public cepError = false

  constructor(
    private injector: Injector,
    private fb: FormBuilder,
    private map: MapService,
    private patientService: PatientService,
    private viaCepService: ViaCepService
  ) {
    super(injector);

    this.childForm = this.fb.group({
      cep: new FormControl(null, [Validators.required, Validators.pattern(/^\d{5}-?\d{3}$/)]),
      number: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      street: new FormControl(null, [Validators.required]),
      district: new FormControl(null, [Validators.nullValidator]),
      complement: new FormControl(null, [Validators.nullValidator]),
    });
  }

  ngOnInit(): void {
    this.address = addressInitialState;

    if (this.mode == 'CREATE') {
      this.patientId = this.patient.patient_id;
      return
    }

    this.getPatient();
  }

  setValueToFormAddress(address?: Address) {
    if (!address) return;

    this.address.city = address?.city;
    this.childForm.controls['cep'].setValue(address?.cep);
    this.address.cep = address?.cep;
    this.address.state = address?.state;
    this.address.country = address?.country;
    this.address.district = address?.district;
    this.address.street = address.street;
    this.address.number = address.number;
    this.address.complement = address.complement;
  }

  buscarCEP() {
    const config: MatDialogConfig = {
      width: '400px',
      maxWidth: '90%',
      minHeight: '200px',
    };

    this.dialog
      .openComponentDialog(
        SearchCepComponent,
        {
          param: {},
        },
        config
      )
      .subscribe((result: addressI) => {
        if (result.cep) {
          this.childForm.controls['cep'].setValue(result.cep);
          this.address.latitude = result.latitude;
          this.address.longitude = result.longitude;
          this.address.street = result.street;
          this.address.city = result.city;
          this.address.state = result.state;
          this.address.complement = result.complement;
          this.address.country = result.country;
          this.address.district = result.district;
        }
      });
  }

  private getPatient() {
    const patientId = this.getUserLogged().id;

    this.patientService.showNew(patientId).subscribe({
      next: (patient: Patient) => {
        this.patient = patient;
        this.setValueToFormAddress(this.patient.address);

        this.onUpdatePatient.emit(patient)
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  searchAddressByCep() {

    this.submittedCep = true
    this.cepError = false

    const cep = this.childForm.controls['cep'].value

    this.viaCepService.findByCep(cep).subscribe({
      next: (res: any) => {

        if (!res.cep) {
          this.submittedCep = false
          this.cepError = true
          return
        }

        this.address.city = res?.localidade;
        this.address.state = res.uf;
        this.address.country = 'Brasil';
        this.address.street = res?.logradouro;

         this.submittedCep = false

        this.onChangeForm({})
      },
      error: (err: HttpErrorResponse) => {
        this.submittedCep = false
        this.cepError = true

      },
    });
  }

  save() {
    this.showErrorMessage = false;
    this.showSuccessMessage = false;
    this.loading = true;
    this.isSavingSettings = true;

    const patientId = this.getUserLogged().id;
    this.patient.address = this.address;

    this.patientService.updateNew(patientId, this.patient).subscribe({
      next: (patient: Patient) => {
        this.patient = patient;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
        this.loading = false;
        this.isSavingSettings = false;

        this.onUpdatePatient.emit(patient)
      },
      error: (err) => {
        this.showErrorMessage = true;
        this.showSuccessMessage = false;
        this.loading = false;
        this.isSavingSettings = false;
        console.log(err);
      },
    });
  }

  loadAddress(cep: string) {
    if (cep.length == 8) {
      const values = this.map.getLatLong(cep);
    }
  }

  onChangeForm(event: any) {
    this.address.cep = this.layout.getOnlyNumbers(this.childForm.get('cep')?.value).toString();
    this.childForm.patchValue({
      cep: this.address?.cep || null,
      number: this.address?.number || null,
      country: 'Brasil',
      city: this.address?.city || null,
      state: this.address?.state || null,
      street: this.address?.state || null,
      district: this.address?.district || null,
      complement: this.address?.complement || null,
    })
  }

  markAsTouched() {
    for (var i in this.childForm.controls) {
      this.form.controls[i].markAsTouched();
    }
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const inputChar = event.key;

    if (!/^[a-zA-ZÀ-ÿ\s]$/.test(inputChar)) {
      event.preventDefault();
    }
  }
}
